import { module } from 'angular';

import { default as historySocialNetworkName, HistorySocialNetwork } from './social-network-history.component';

export default module('contact.commons.history.social-network', []).component(historySocialNetworkName, new HistorySocialNetwork()).name;
